export default __webpack_public_path__ + "static/media/error_icon.c617e45e.svg";